{
  "name": "m3-hug",
  "seed": 1,
  "track": "ring",
  "fixedDtMs": 16.666666666666668,
  "cars": [{ "id": "player", "spawn": { "x": 860, "y": 360, "angle": 0 }, "ai": null }],
  "inputs": [{ "frame": 0, "car": 0, "throttle": 1, "steer": 0, "handbrake": false }],
  "captures": [{ "frame": 60, "name": "hit" }]
}
